import { useFormField as useLegacyFormGroupField } from '../FormGroup'

/**
 * Identidade herdada do `FormGroup` legado.
 *
 * Um controle desta camada pode ser montado dentro do wrapper antigo — é o que
 * acontece nas telas que ainda não migraram, e o que permite adoção
 * incremental. O `FormGroup` já passa `id` e `aria-describedby` por prop, mas o
 * **nome acessível** vem de `aria-labelledby`, que ele publica apenas no
 * contexto. Sem consumir esse contexto, o campo fica sem nome e o `htmlFor` do
 * rótulo vira referência pendurada.
 *
 * Fora do `FormGroup` — inclusive dentro do `Field` novo, que injeta os mesmos
 * atributos pelo `Slot` — devolve objeto vazio e nada é sobrescrito.
 */
export function useLegacyFieldAria(name?: string) {
  const field = useLegacyFormGroupField?.()

  // O `FormGroup` normalmente não declara `name` — ele fica no controle
  // aninhado. A herança vale quando o grupo não nomeia campo algum, e é
  // restrita ao campo certo quando nomeia. Mesma regra do `FormControl`.
  const inherits = !!field && (field.name == null || field.name === name)

  if (!inherits) return {}

  return {
    id: field.controlId,
    'aria-labelledby': field.labelId,
    'aria-describedby': field.describedBy
  }
}
